module.exports = __webpack_public_path__ + "static/img/kfwx.6423211.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/kfwx.jpg
// module id = PqOt
// module chunks = 19